<template>
    <div>
        <div v-if="isChinese" class="marketo-form">
            <Typography class="title" variant="h3-display" as="h3">{{ $t('马上订阅') }}</Typography>
            <Typography class="description" variant="body-display-small" as="p">{{
                formDescriptionChinese
            }}</Typography>
            <form id="mktoForm_1016"></form>
            <div id="confirmFormCTWEngage" style="display: none">
                <strong>谢谢</strong>
                <p>请查看您的电子邮件，其中包含登录到carnegieendowment.org网站的链接，您可通过此链接修改个人偏好。</p>
            </div>
        </div>
        <div v-else class="marketo-form">
            <Typography class="title" variant="h3-display" as="h3">{{ $t('Subscribe Today') }}</Typography>
            <Typography class="description" variant="body-display-small" as="p">{{
                formDescriptionEnglish
            }}</Typography>
            <form id="mktoForm_1001"></form>
            <div id="confirmFormCTWEngage" style="display: none">
                <strong>Thank you!</strong>
                <p>Check your email for details on your request.</p>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    formContextData: {
        type: Object,
    },
    formDescriptionChinese: {
        type: String,
        default: '注册接收卡内基的邮件通知。',
    },
    formDescriptionEnglish: {
        type: String,
        default:
            'Subscribe to receive a monthly newsletter of the latest analysis from Carnegie China, as well as announcements and invitations to Carnegie China’s public events.',
    },
});
const { locale } = useLocale();
const isChinese = computed(() => {
    return locale._value === 'zh';
});
function formCCEn() {
    MktoForms2.loadForm('//Pages.carnegieendowment.org', '813-XYU-422', 1001, function (form) {
        // Set values for the hidden fields, "Site_Source__c"
        // Note that these fields were configured in the form editor as hidden fields already
        form.vals({ Site_Source__c: 'CC SubscribePage Mkto En' });
    });
    MktoForms2.whenReady(function (form) {
        //Add an onSubmit to add hidden field values
        form.onSubmit(function (form) {
            form.addHiddenFields({ englishNewsletterAll: 'ctcEnglish' });
            form.addHiddenFields({ centerAffiliationAll: 'beijing' });
        });
        //Add an onSuccess handler
        form.onSuccess(function (values, followUpUrl) {
            //get the form's jQuery element and hide it
            form.getFormElem().hide();
            document.getElementById('confirmFormCTWEngage').style.display = 'block';
            //return false to prevent the submission handler from taking the lead to the follow up url.
            return false;
        });
    });
}
function formCCZh() {
    MktoForms2.loadForm('//Pages.carnegieendowment.org', '813-XYU-422', 1016, function (form) {
        // Set values for the hidden fields, "Site_Source__c"
        // Note that these fields were configured in the form editor as hidden fields already
        form.vals({ Site_Source__c: 'CC SubscribePage Mkto Zh' });
    });
    MktoForms2.whenReady(function (form) {
        //Add an onSubmit to add hidden field values
        form.onSubmit(function (form) {
            form.addHiddenFields({ nonEnglishNewsletterAll: 'ctcChinese' });
            form.addHiddenFields({ centerAffiliationAll: 'beijing' });
        });
        //Add an onSuccess handler
        form.onSuccess(function (values, followUpUrl) {
            //get the form's jQuery element and hide it
            form.getFormElem().hide();
            document.getElementById('confirmFormCTWEngage').style.display = 'block';
            //return false to prevent the submission handler from taking the lead to the follow up url.
            return false;
        });
    });
}
onMounted(() => {
    if (locale._value === 'en') {
        formCCEn();
    }
    if (locale._value === 'zh') {
        formCCZh();
    }
});
</script>

<style lang="scss" scoped>
@import './././assets/styles/core/marketoForms';
</style>
